import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import './HelpCategoryPage.css';

/**
 * Creating an Account Article Page
 */
const Welcome = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Creating an Account</h1>
                <p className="article-subtitle">
                  Start managing your expenses in seconds using your phone, email, or Phantom wallet.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Choose your login method</h2>
                  <p className="article-section-intro">
                    At WeSplit, you can create an account using a traditional method or by connecting your existing Web3 wallet.
                  </p>
                </div>

                <div className="article-subsection">
                  <h3 className="article-subsection-title">Email or Phone</h3>
                  <p className="article-subsection-description">
                    Update personal and account-related configurations.
                  </p>
                  <ol className="article-list">
                    <li>
                      <strong>Enter your details:</strong> On the welcome screen, type your Phone Number or Email Address.
                    </li>
                    <li>
                      <strong>Verification:</strong> You will receive a 6-digit verification code via SMS or email. Enter it to verify your identity.
                    </li>
                    <li>
                      <strong>Wallet Creation:</strong> WeSplit automatically creates a fresh wallet linked to your account. You don't need to do anything else!
                    </li>
                  </ol>
                  <div className="article-note">
                    <p>Make sure to check your spam folder if you don't receive the email code within a minute.</p>
                  </div>
                </div>

                <div className="article-subsection">
                  <div className="article-subsection">
                    <h3 className="article-subsection-title">Phantom Connect</h3>
                    <p className="article-subsection-description">
                      Ideal for Web3 users who want to use their own funds and transaction history.
                    </p>
                  </div>
                  <ol className="article-list">
                    <li>
                      <strong>Select Method:</strong> Choose between Google & Apple.
                    </li>
                    <li>
                      <strong>Approve Connection:</strong> Your Phantom app will open. Confirm the connection request (SSO).
                    </li>
                    <li>
                      <strong>Sign Message:</strong> You may be asked to sign a message to verify ownership. This is free and secure.
                    </li>
                  </ol>
                  <div className="article-note">
                    <p>Why use Phantom? By connecting Phantom, you use your existing wallet directly within WeSplit. No new wallet is created, keeping all your assets in one place.</p>
                  </div>
                </div>
              </section>


              <section className="article-section">
                <h2 className="article-section-title">Setting up your profile</h2>
                <p className="article-section-intro">
                  Once your account is created, give it a personal touch so your friends can recognize you easily.
                </p>
                <ul className="article-list-dots">
                  <li>
                    <strong>Set a Pseudo:</strong> Choose a unique username (e.g., @PauluneMoon). This will be visible in all your groups.
                  </li>
                  <li>
                    <strong>Profile Picture:</strong> Upload a photo.
                  </li>
                </ul>
              </section>

              <div className="article-separator"></div>


              <LastUpdated />

              <ArticleNavigation
                next={{
                  title: 'Secure your Account',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'first-split'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Welcome;
